import { ImageProps } from 'next/image'

import { FeaturedTag } from '../../types/fam-graphql'
import { colors } from '../../theme'
import ActionButton from '../../components/ActionButton'
import { ContentCardVariant } from '../../components/ContentCard/styled'
import Router from '../../routes/router'
import routes from '../../routes/definitions'
import { app } from '../../configuration'

export const featuredTagCardTransformer = (
  cl: FeaturedTag,
  t: any,
  isOffline?: boolean
) => {
  const singleButtonActionProps = Router.getRouteConfig(
    routes.recipesByTag.name,
    {
      tag: cl?.tag?.name,
    }
  )

  return {
    backgroundColor: colors.redMandy,
    imageProps: {
      src: cl?.image ?? app.ASSET_PREFIX + '/images/default/placeholder.png',
      alt: cl?.tag?.name ?? '',
      objectFit: 'cover',
      layout: 'fill',
      unoptimized: isOffline,
    } as ImageProps,
    singleButtonActionProps,
    firstHighlightText: t(`breadcrumb_recipes_by_tag`),
    secondHighlightText: cl?.tag?.name ?? '',
    variant: ContentCardVariant.Default,
    buttons: (
      <>
        <ActionButton
          text={t('recipe_see_recipes_cta')}
          variantType="fake"
          actionProps={singleButtonActionProps}
        />
      </>
    ),
  }
}
